<template>
    <q-page padding>
        <q-tabs v-model="tab" color="white" text-color="primary" underline-color="primary" class="shadow-1 bg-white" align="justify">
            <q-tab slot="title" name="live_class" :label="$t('live_class')" icon="fas fa-chalkboard-teacher" />

            <q-tab-pane name="live_class" class="q-px-md q-pb-xl q-mt-md">
                <div>
                    <div class="row gutter-sm" v-if="$q.platform.is.desktop">
                        <div class="col-sm-11">
                            <p class="q-title">{{ title }}</p>
                            <p class="q-body-1 text-weight-light">{{ description }}</p>
                            <p class="q-body-1 text-weight-light">{{ `${$t('timezone')}: ${timezone}` }}</p>
                        </div>

                        <div class="col-sm-1 cursor-pointer" @click="showCertificate()">
                            <vc-donut :sections="sections" :size="100" unit="%">
                                <h6 v-if="user_progress < 100 && live_class_user_result_status != 1 && live_class_user_result_status != 2" class="text-primary">
                                    {{ getPercentage(user_progress) }}%
                                </h6>


                                <q-icon :name="getResult" :color="getResultColor" size="2rem" v-if="user_progress == 100 || live_class_user_result_status == 1 || live_class_user_result_status == 2" />

                                <q-tooltip v-if="live_class_user_result_status == 2">
                                    {{ `${$t('you_were_reproved_in')} ${live_class_user_result_date}` }}
                                </q-tooltip>
                            </vc-donut>
                        </div>
                    </div>

                    <div class="row gutter-xs" v-if="$q.platform.is.mobile">

                        <div class="col-xs-10">
                            <p class="q-title">{{ title }}</p>
                        </div>

                        <div class="col-xs-2 cursor-pointer" @click="showCertificate()">
                            <vc-donut :sections="sections" :size="100" unit="%">
                                <h6 v-if="user_progress < 100 && live_class_user_result_status != 1 && live_class_user_result_status != 2" class="text-primary">
                                    {{ getPercentage(user_progress) }}%
                                </h6>


                                <q-icon :name="getResult" :color="getResultColor" size="2rem" v-if="user_progress == 100 || live_class_user_result_status == 1 || live_class_user_result_status == 2" />

                                <q-tooltip v-if="live_class_user_result_status == 2">
                                    {{ `${$t('you_were_reproved_in')} ${live_class_user_result_date}` }}
                                </q-tooltip>
                            </vc-donut>
                        </div>

                        <div class="col-xs-12 col-sm-11">
                            <p class="q-body-1 text-weight-light">{{ description }}</p>
                            <p class="q-body-1 text-weight-light">{{ `${$t('timezone')}: ${timezone}` }}</p>
                        </div>
                    </div>

                    <div class="row reverse gutter-sm q-mt-sm">
                        <div class="col-xs-12 col-sm-2">
                            <q-btn :label="$t('back')" color="primary" icon="fas fa-chevron-left" class="full-width" @click="$router.push({ name: 'live_classes' })" />
                        </div>
                    </div>

                    <q-tabs v-model="tab_live_class" color="primary" underline-color="secondary" align="justify" class="q-mt-md">
                        <q-tab slot="title" name="live_classes" :label="$q.platform.is.desktop ? `${$t('live_class')}` : ''" icon="fas fa-chalkboard-teacher" />
                        <q-tab slot="title" name="reaction_test" :label="$q.platform.is.desktop ? `${$t('reaction_test')}` : ''" icon="fas fa-clipboard-check" />

                        <q-tab-pane name="live_classes" class="q-px-md q-pb-md">
                            <q-table
                                ref="table"
                                :pagination.sync="server_pagination"
                                :data="activities"
                                :columns="columns"
                                @request="requestActivities"
                                :loading="loading"
                                row-key="id"
                                :no-data-label="$t('no_data_avaliable')"
                                :no-results-label="$t('no_results_found')"
                                :loading-label="$t('loading_data')"
                                :rows-per-page-label="$t('items_per_page')"
                                :rows-per-page-options="[0]"
                                hide-bottom
                                class="shadow-0"
                                v-if="$q.platform.is.desktop"
                                >

                                <q-tr slot="header" slot-scope="props" :props="props">
                                    <q-th v-for="col in props.cols" :key="col.name" :props="props">
                                    {{ $t(col.label) }}
                                    </q-th>
                                </q-tr>

                                <template slot="body" slot-scope="props">
                                    <q-tr :props="props" :class="getRowClass(props.row)">
                                        <q-td key="type_title" :props="props">
                                            {{ props.row.type_title }}
                                        </q-td>

                                        <q-td key="type_slug" :props="props">
                                            <q-icon :name="getIcon(props.row.type_slug)" size="1rem" class="q-mr-sm" />
                                            {{ $t(getType(props.row.type_slug)) }}
                                        </q-td>

                                        <q-td key="platform_type" :props="props">
                                            {{ getLiveClassPlatformTypes(props.row.platform_type) }}
                                        </q-td>

                                        <q-td key="score" :props="props">
                                            {{ props.row.score }}
                                        </q-td>

                                        <q-td key="user_watch" :props="props" auto-width>
                                            <q-icon name="fas fa-ban" size="1.5rem" color="negative" v-if="props.row.is_blocked" />
                                            <q-icon name="far fa-check-circle" size="1.5rem" color="positive" v-else-if="props.row.is_approved" />
                                            <q-icon name="far fa-circle" size="1.5rem" color="primary" v-else-if="props.row.type_slug !== 'live_class'" />
                                        </q-td>

                                        <q-td key="actions" :props="props">
                                            <q-btn color="primary" class="full-width" :label="$t(getLabelBtn(props.row))" :icon="getIconBtn(props.row)" @click="btnClicked(props.row)" :disable="getDisableButton(props.row)" />
                                        </q-td>
                                    </q-tr>
                                </template>
                            </q-table>

                            <q-card class="bg-grey-1 q-mt-md" v-for="(activity, index) in activities" :key="index" :class="getRowClass(activity)" v-if="$q.platform.is.mobile">
                                <q-card-main class="relative-position">
                                    <div class="line-card bg-primary absolute-top"></div>

                                    <div class="row gutter-sm vertical-middle">
                                        <div class="col-9">
                                            <p>
                                                <q-icon name="fas fa-ban" size="1rem" color="negative" v-if="activity.is_blocked" />
                                                <q-icon name="far fa-check-circle" size="1rem" color="positive" v-else-if="activity.is_approved" />
                                                <q-icon name="far fa-circle" size="1.5rem" color="primary" v-else-if="activity.type_slug !== 'live_class'" />
                                                <span class="q-ml-sm q-subheading">{{ activity.type_title }}</span>
                                            </p>
                                        </div>

                                        <div class="col-3 text-right">
                                            <q-icon :name="getIcon(activity.type_slug)" size="3rem" color="secondary" />
                                        </div>
                                    </div>
                                </q-card-main>

                                <q-card-separator />

                                <q-card-actions>
                                    <q-btn color="primary" class="full-width" :label="$t(getLabelBtn(activity))" :icon="getIconBtn(activity)" @click="btnClicked(activity)" :disable="getDisableButton(activity)" />
                                </q-card-actions>
                            </q-card>
                        </q-tab-pane>

                        <q-tab-pane name="reaction_test" class="q-px-md q-pb-xl q-mt-md">
                            <reaction-test />
                        </q-tab-pane>

                    </q-tabs>
                </div>
            </q-tab-pane>
        </q-tabs>

        <q-modal v-if="show_modal_class_room" v-model="show_modal_class_room" :content-css="{minWidth: '100vw', minHeight: '100vh'}" no-backdrop-dismiss no-esc-dismiss @hide="hideModalClassRoom">
            <q-modal-layout>
                <q-toolbar slot="header">
                    <q-btn flat round dense @click="hideModalClassRoom()" icon="fas fa-times" />
                    <q-toolbar-title>
                        {{ selected_live_class.title }}
                    </q-toolbar-title>
                </q-toolbar>

                <class-room v-if="show_modal_class_room" :room="live_class_room"  @hideModalClassRoom="hideModalClassRoom" />
            </q-modal-layout>
        </q-modal>

        <q-modal v-model="show_modal_test" :content-css="{minWidth: getMinWidth, maxWidth: getMaxWidth, minHeight: '90vh'}" no-backdrop-dismiss no-esc-dismiss>
            <q-modal-layout>
                <q-toolbar slot="header">
                    <q-btn flat round dense @click="hideModalTest()" icon="fas fa-times" />
                    <q-toolbar-title>
                        {{ test.title }}
                    </q-toolbar-title>
                </q-toolbar>

                <test :test="test" v-if="test" @clearTest="hideModalTest" />
            </q-modal-layout>
        </q-modal>

        <q-dialog
            v-model="show_meet_dialog"
            stack-buttons
            prevent-close
            @cancel="show_meet_dialog = false"
            @hide="show_meet_dialog = false"
        >
            <span slot="title">{{$t('window_blocked')}}</span>
            <span slot="message">
                {{ $t('browser_window_blocked_click') }}
                <a :href="live_class_external_url" target="_blank" rel="noopener noreferrer">{{$t('here')}}</a>
                {{ $t('to_access_the_class')}}
                </span>
        </q-dialog>

        <certificate v-if="show_certificate" :show="show_certificate" :data="certificate_data" @hideCertificate="hideCertificate" />
    </q-page>
</template>

<script>
import { mapGetters } from 'vuex'
import Test from 'components/live_classes/Test'
import ReactionTest from 'components/live_classes/ReactionTest'
import Certificate from 'components/live_classes/Certificate'
import { date } from 'quasar'
const { formatDate } = date
import * as moment from 'moment'
import * as tz from 'moment-timezone'
import { db } from 'plugins/vuefire'
import firebase from 'firebase/app'
import 'firebase/app'
import 'firebase/firestore'
import 'firebase/database'
import 'firebase/auth'


export default {
    i18nOptions: { namespaces: [ 'custom', 'common', 'admin', 'courses', 'presential', 'live_classes' ] },

    data() {
        return {
            tab: 'live_class',
            tab_live_class: 'live_classes',
            title: '',
            description: '',
            timezone: '',
            live_class_user_result_status: '',
            user_progress: 0,
            live_class_room: '',
            sections: [],
            show_certificate: false,
            certificate_data: [],
            live_class: [],
            server_pagination: {
                page: 1,
                rowsNumber: 10,
                rowsPerPage: 0,
                descending: false,
                sortBy: 'order'
            },
            columns: [
                {
                    name: 'type_title',
                    required: true,
                    label: 'title',
                    align: 'left',
                    field: 'type_title',
                    sortable: false,
                },
                {
                    name: 'type_slug',
                    required: true,
                    label: 'type_activity',
                    align: 'left',
                    field: 'type_slug',
                    sortable: false,
                },
                {
                    name: 'platform_type',
                    required: true,
                    label: 'platform',
                    align: 'left',
                    field: 'platform_type',
                    sortable: false,
                },
                {
                    name: 'score',
                    required: true,
                    label: 'score',
                    align: 'left',
                    field: 'score',
                    sortable: false,
                },
                {
                    name: 'user_watch',
                    required: true,
                    label: 'status',
                    align: 'center',
                    field: 'user_watch',
                    sortable: false,
                },
                {
                    name: 'actions',
                    required: true,
                    label: '',
                    align: 'right',
                    field: 'actions',
                    sortable: false,
                }
            ],
            loading: false,
            activities: [],
            show_modal_class_room: false,
            selected_live_class: {},
            test: {},
            show_modal_test: false,
            live_class_status: '',
            live_class_type: null,
            live_class_user_result_date: '',
            show_meet_dialog: false,
            live_class_external_url: null
        }
    },

    components: {
        'class-room': () => import('components/live_classes/ClassRoom.vue'),
        'test': Test,
        'certificate': () => import('components/Certificate'),
        'reaction-test': ReactionTest,
        'certificate': Certificate
    },

    computed: {
        ...mapGetters({
            access_token: 'common/access_token',
            live_class_platform_types: 'registration_lists/live_class_platform_types',
        }),

        getHeader() {
            let headers = {}
            return headers = {
                headers: {
                    'content-type': 'application/json',
                    'authorization': 'Basic ' + btoa(process.env.APP_CLIENT_ID + ':' + process.env.APP_CLIENT_SECRET),
                    'authorization': 'Bearer ' + this.access_token
                }
            }
        },

        getResult() {
            if (this.live_class_user_result_status == 1) {
                return 'fas fa-trophy'
            }
            else if (this.live_class_user_result_status == 2) {
                return 'fas fa-ban'
            }
        },

        getResultColor() {
            if (this.live_class_user_result_status == 1) {
                return 'positive'
            }
            else if (this.live_class_user_result_status == 2) {
                return 'negative'
            }
        },

        getMaxWidth() {
            if (this.$q.platform.is.mobile) return '100vw'
            else return '90vw'
        },

        getMinWidth() {
            if (!this.$q.platform.is.mobile) return '90vw'
        }
    },

    methods: {
        requestActivities({ pagination }) {
            this.loading = true
            this.server_pagination = pagination

            this.$axios.all([this.fetchLiveClass(), this.fetchTests()])
            .then(this.$axios.spread((liveClass, tests) => {
                this.activities = []

                this.title = liveClass.data.title
                this.description = liveClass.data.description
                this.live_class_room = liveClass.data.code_room
                this.timezone = this.getHumanTimezone(liveClass.data.timezone)

                this.live_class_status = liveClass.data.status

                this.live_class_type = liveClass.data.type
                this.live_class_id = liveClass.data.id

                this.activities.push({
                    id: liveClass.data.id,
                    type_title: liveClass.data.title,
                    type_slug: 'live_class',
                    platform_type: liveClass.data.platform_type,
                    embed: liveClass.data.embed,
                    user_watch: liveClass.data.live_class_user_result_status,
                    score: liveClass.data.score > 0 ? liveClass.data.score : '',
                    actions: liveClass.data.id
                })

                this.live_class_user_result_status = liveClass.data.live_class_user_result_status
                this.user_progress = liveClass.data.user_progress
                this.live_class_user_result_date = liveClass.data.live_class_user_result_date
                if (this.live_class_user_result_date) this.live_class_user_result_date = date.formatDate(this.live_class_user_result_date, 'DD/MM/YYYY')
                tests.data.forEach(test => {
                    this.activities.push({
                        id: test.id,
                        type_title: test.title,
                        type_slug: test.type_slug,
                        user_watch: test.status,
                        actions: test.id,
                        allowed_to_answer: test.allowed_to_answer,
                        is_approved: test.is_approved,
                        is_blocked: test.is_blocked,
                        score: test.test_score > 0 ? test.test_score : '',
                        user_test_results: test.user_test_results
                    })
                })

                this.sections = []


                if (this.live_class_user_result_status != 2) {
                    this.sections.push({
                        value: this.user_progress ? this.user_progress > 100 ? 100 : this.user_progress : 0,
                        color: this.getDonutColor(this.user_progress)
                    })
                }
                else {
                    this.sections.push({
                        value: 100,
                        color: '#DB2828'
                    })
                }

                this.server_pagination.rowsNumber = this.activities.length

                this.loading = false
            }))
            .catch(e => {
                this.loading = false
                console.log(e)

                this.$q.notify({
                    message: this.$t('live_class_not_found'),
                    type: 'negative',
                    icon: 'fas fa-ban'
                })

                this.$router.push({ name: 'live_classes' })
            })
        },

        fetchLiveClass() {
            return this.$axios.get(`etraining_live_classes/live_classes/${this.$route.params.id}/`, this.getHeader)
        },

        fetchTests() {
            return this.$axios.get(`etraining_live_classes/live_classes/${this.$route.params.id}/live_class_test/`, this.getHeader)
        },

        btnClicked(activity) {
            if (activity.type_slug === 'live_class') {

                if (activity.platform_type === 1) {
                    this.$q.loading.show()

                    this.$axios.get(`/etraining_live_classes/live_classes/${activity.id}/open/`, this.getHeader)
                    .then(response => {
                        this.openWebcast(activity.id, response.data)
                    })
                    .catch(e => {
                        this.$q.loading.hide()
                        console.log(e)
                    })
                } else {
                    this.openMeeting(activity)
                }

            }
            else {
                this.$q.loading.show()

                this.$axios.get(`/etraining_live_classes/live_classes/${this.$route.params.id}/live_class_test/${activity.id}/`, this.getHeader)
                .then(response => {
                    this.test = response.data
                    this.$q.loading.hide()
                    this.show_modal_test = true
                })
                .catch(e => {
                    this.$q.loading.hide()
                    console.log(e)
                })
            }
        },

        openWebcast(id, data) {
            this.$axios.get(`/etraining_live_classes/live_classes/${id}/open/`, this.getHeader)
            .then(response => {
                this.selected_live_class = data
                this.show_modal_class_room = true
                this.setUserOnlineFirebase()
            })
            .catch(e => {
                console.log(e)
            })
            .finally(() => {
                this.$q.loading.hide()
            })
        },

        openMeeting(activity) {
            this.$axios.get(`/etraining_live_classes/live_classes/${activity.id}/open/`, this.getHeader)
            .then(response => {
                this.live_class_external_url = activity.embed
                let meet = window.open(this.live_class_external_url, '_blank')
                if (meet === null) {
                    this.show_meet_dialog = true
                } else return
            })
            .catch(e => {
                console.log(e)
            })
            .finally(e => {
                this.reloadActivity()
            })
        },

        getLiveClassPlatformTypes (platform) {
            if (this.live_class_platform_types) {
                const platformType = this.live_class_platform_types.find(type => platform === type.value)
                return platformType && platformType.label ? platformType.label : ''
            } else return ''
        },

        hideModalClassRoom() {
            this.show_modal_class_room = false
            this.setUserOfflineFirebase()
            this.requestActivities({ pagination: this.server_pagination })
        },

        hideModalTest() {
            this.show_modal_test = false
            this.requestActivities({ pagination: this.server_pagination })
        },

        getRowClass(activity) {
            if (activity.type_slug != 'live_class') {
                if (this.live_class_status != 4) return 'blocked-activity text-faded'
            }
            return 'cursor-pointer'
        },

        getDisableButton(activity) {
            if (activity.type_slug != 'live_class') {
                if (this.live_class_status != 4) return true
            }
            return false
        },

        getIcon(slug) {
            switch(slug) {
                case 'live_class': return 'fas fa-chalkboard-teacher'
                break
                case 'conventional_test':
                case 'restart_test':
                case 'block_test': return 'fas fa-check-double'
                break
                case 'evaluated_quiz':
                case 'unevaluated_quiz': return 'far fa-check-square'
                break
            }
        },

        getType(slug) {
            switch(slug) {
                case 'live_class': return 'live_class'
                break
                case 'conventional_test': return 'conventional_test'
                break
                case 'block_test': return 'block_test'
                break
                case 'restart_test': return 'restart_test'
                break
                case 'evaluated_quiz': return 'evaluated_quiz'
                break
                case 'unevaluated_quiz': return 'unevaluated_quiz'
                break
            }
        },

        getLabelBtn(activity) {
            if (activity.type_slug === 'live_class') return 'watch'
            else return 'answer'
        },

        getIconBtn(activity) {
            if (activity.type_slug === 'live_class') return 'far fa-eye'
            else return 'fas fa-pen'
        },

        getPercentage(percentage) {
            if (!percentage) {
                return 0
            }
            else if (percentage < 100) {
                return parseInt(percentage)
            }
        },

        getDonutColor(percentage) {
            if (percentage > 0 && percentage <= 24) {
                return '#DB2828'
            }
            else if (percentage >= 25 && percentage <= 74) {
                return '#F2C037'
            }
            else if(percentage >= 75) {
                return '#21BA45'
            }
        },

        reloadActivity() {
            this.$axios.get(`/etraining_live_classes/live_classes/${this.$route.params.id}/`, this.getHeader)
            .then(response => {
                this.user_progress = response.data.user_progress ? parseInt(response.data.user_progress) : 0
                this.webcast_user_result_status = response.data.webcast_user_result_status

                this.sections = []

                if (this.webcast_user_result_status != 2) {
                    this.sections.push({
                        value: this.user_progress ? this.user_progress : 0,
                        color: this.getDonutColor(this.user_progress)
                    })
                }
                else {
                    this.sections.push({
                        value: 100,
                        color: '#DB2828'
                    })
                }

            })
            .catch(e => {
                console.log(e)
            })
        },

        showCertificate() {
            if (this.live_class_user_result_status) {
                this.$q.loading.show()

                this.$axios.get(`/etraining_live_classes/live_classes/${this.$route.params.id}/certificate/`, this.getHeader)
                .then(response => {
                    this.certificate_data = response.data
                    this.show_certificate = true
                    this.$q.loading.hide()
                })
                .catch(e => {
                    this.$q.loading.hide()
                    console.log(e)
                })
            }
        },

        hideCertificate() {
            this.show_certificate = false
            this.certificate_data = []
        },

        setUserOnlineFirebase() {
            if (this.live_class_status != 4) {
                let { uid } = firebase.auth().currentUser
                let userStatus = firebase.database().ref(`/live_class_user_status/${this.$route.params.id}/${uid}`)
                let userOnline = firebase.database().ref(`/live_class_user_online/${uid}`)

                let isOnlineForDatabase = {
                    st: 'on',
                    dt: firebase.database.ServerValue.TIMESTAMP,
                    we: parseInt(this.$route.params.id.toString())
                }

                let isOfflineForDatabase = {
                    st: 'off',
                    dt: firebase.database.ServerValue.TIMESTAMP,
                    we: parseInt(this.$route.params.id)
                }

                firebase.database().ref('.info/connected').on('value', (snapshot) => {
                    userStatus.onDisconnect().set(isOfflineForDatabase).then(() => {
                        userStatus.set(isOnlineForDatabase)
                    })
                })

                firebase.database().ref('.info/connected').on('value', (snapshot) => {
                    userOnline.onDisconnect().set(isOfflineForDatabase).then(() => {
                        userOnline.set(isOnlineForDatabase)
                    })
                })
            }
        },

        setUserOfflineFirebase() {
            if (this.live_class_status != 4) {
                let { uid } = firebase.auth().currentUser
                let userStatus = firebase.database().ref(`/live_class_user_status/${this.$route.params.id}/${uid}`)
                let userOnline = firebase.database().ref(`/live_class_user_online/${uid}`)

                let isOfflineForDatabase = {
                    st: 'off',
                    dt: firebase.database.ServerValue.TIMESTAMP,
                    we: parseInt(this.$route.params.id)
                }

                userStatus.set(isOfflineForDatabase)
                userOnline.set(isOfflineForDatabase)
            }
        },

        getPercentage(percentage) {
            if (!percentage) {
                return 0
            }
            else if (percentage < 100) {
                return parseInt(percentage)
            }
        },

        getHumanTimezone(location) {
            const gmt = moment.tz(location).format('z')
            if (gmt === 'GMT') {
                return `${gmt} 0`
            } else return `GMT ${gmt}`
        }
    },

    beforeDestroy () {
        if (this.show_modal_class_room) {
            this.setUserOfflineFirebase()
        }
    },

    beforeRouteLeave (to, from, next) {
        if (this.show_modal_class_room) {
            this.setUserOfflineFirebase()
        }
        next()
    },

    created() {
        this.requestActivities({ pagination: this.server_pagination })
    },

    watch: {
        $route: function (to, from) {
            this.server_pagination = {
                page: 1,
                rowsNumber: 10,
                rowsPerPage: 0,
                descending: false,
                sortBy: 'order'
            },
            this.requestActivities({ pagination: this.server_pagination })
        }
    },
}
</script>

<style>

</style>
